import React from 'react'
import { Button, Dialog, DialogContent, DialogActions, makeStyles, TextField } from '@material-ui/core'

const useStyles = makeStyles(theme => ({
    dialog: {
        padding: theme.spacing(2),
        width: 500
    },
    dialogContent: {
        textAlign: 'center'
    },
    dialogAction: {
        justifyContent: 'center'
    },
    textfield: {
        width: '100%',
        padding: 10
    }
}))

export default function EditDialog(props) {

    const { editDialog, setEditDialog, editVal, setEditVal, onUpdateEditEmail } = props;
    const classes = useStyles()

    const onChange = (e) => {
        setEditVal(e.target.value)
    }
    return (
        <Dialog open={editDialog.isOpen} classes={{ paper: classes.dialog }}>
            <DialogContent className={classes.dialogContent}>
                <TextField
                    className={classes.textfield}
                    id="email"
                    name="email"
                    variant='outlined'
                    multiline
                    rows={5}
                    rowsMax={10}
                    size="small"
                    value={editVal}
                    helperText={'To add a list, separate emails with a comma (,)'}
                    onChange={(e) => onChange(e)}
                />
                   
            </DialogContent>
            <DialogActions className={classes.dialogAction}>
                <Button
                    color="default"
                    onClick={!editDialog.onCancel ? () => {
                        setEditDialog({ ...editDialog, isOpen: false })
                        setEditVal('')
                    }
                    : () => editDialog.onCancel()}>
                    Cancel
                    </Button>
                <Button
                    color="primary"
                    variant='contained'
                    style={{width: 100}}
                    onClick={() => onUpdateEditEmail(editDialog.indexToUpdate)}>
                    {editDialog.isCreating ? "Add" : "Update" }
                    </Button>
            </DialogActions>
        </Dialog>
    )
}
